import { db, FirebaseDocRefType, FirebaseTimestampType } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { PointCardUserPointType as BasicPointCardUserPointType } from 'types/pointCard/pointCardUserPoint'

type PointCardUserPointType = BasicPointCardUserPointType & { ref: FirebaseDocRefType }

const PointCardUserPointConverter = getConverter<PointCardUserPointType>()

export const fetchPointCardUserPoint = (
  pointCardId: string,
  pointCardUserId: string,
  id: string
): Promise<PointCardUserPointType | undefined> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_users')
    .doc(pointCardUserId)
    .collection('point_card_user_points')
    .doc(id)
    .withConverter(PointCardUserPointConverter)
    .get()
    .then((snapshot) => {
      const data = snapshot.data()
      if (!data) {
        return undefined
      }
      return {
        ...data,
        ref: snapshot.ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchPointCardUserPointsByPointCardRef = (
  pointCardRef: FirebaseDocRefType,
  startAt: FirebaseTimestampType,
  endAt: FirebaseTimestampType
): Promise<PointCardUserPointType[]> => {
  return db
    .collectionGroup('point_card_user_points')
    .withConverter(PointCardUserPointConverter)
    .where('point_card_ref', '==', pointCardRef)
    .orderBy('created_at', 'desc')
    .startAt(endAt)
    .endAt(startAt)
    .get()
    .then((snapshots) =>
      snapshots.docs.map((snapshot) => {
        const data = snapshot.data()
        return {
          ...data,
          ref: snapshot.ref,
        }
      })
    )
    .catch((error) => {
      console.error(error)
      return []
    })
}
